module.exports = __webpack_public_path__ + "img/photo-0133.7a5c9dd5.jpg";